import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EventsService} from "../../services/events.service";
import {SettingsService} from "../../services/settings.service";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  // tslint:disable-next-line:max-line-length
  regexUrl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;

  label: string = '';
  url: string = '';
  appendToken: boolean = false;

  errors: string[] = [];
  warnings: string[] = [];

  constructor(
      private events: EventsService,
      public modalService: NgbModal,
      private settingsService: SettingsService
  ) {
  }

  async ngOnInit() {
    this.label = await this.settingsService.get('upload-label');
    this.url = await this.settingsService.get('upload-url');
    this.appendToken = await this.settingsService.get('upload-append-token');
  }

  async saveChanges() {
    this.errors = [];
    this.warnings = [];
    if (!this.url || !this.url.match(this.regexUrl)) {
      this.errors.push('Die angegebene URL ist ungültig.');
    } else if (!this.url.match(/^https?:\/\//)) {
      this.url = 'https://' + this.url;
      this.warnings.push('Die angegebene URL wurde angepasst. Bitte überprüfen Sie die Änderungen!')
    }
    if (!this.label || this.label.match(/^\s.*/)) {
      this.errors.push('Die Beschriftung darf nicht leer sein oder mit einem Leerzeichen beginnen.');
    }
    if (this.errors.length === 0 && this.warnings.length === 0) {
      await this.settingsService.set('upload-label', this.label);
      await this.settingsService.set('upload-url', this.url);
      await this.settingsService.set('upload-append-token', this.appendToken);
      this.events.publish('settings-changed:upload');
      this.modalService.dismissAll();
    }
  }

}
